import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { getStyles, translate } from '../../shared/utility';

import Logo from '../../components/Logo/Logo';
import Modal from '../../components/UI/Modal/Modal';
import Button from '../../components/UI/Button/Button';
import Bar from '../../components/UI/Loading/Bar/Bar';
import AsyncContent from '../../components/UI/AsyncContent/AsyncContent';

import localStyles from './Footer.scss';
const styles = getStyles(localStyles);

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            termsConditionsModalIsOpen: false,
            termsContent: null
        };
    }

    openTermsConditionsModal = (terms) => {
        this.setState({ termsConditionsModalIsOpen: true, termsContent: terms });
    }
    closeTermsConditionsModal = () => {
        this.setState({ termsConditionsModalIsOpen: false, termsContent: null });
    }

    render() {
        const companyContent = [].concat(this.props.communityDetailsData ?
            this.props.communityDetailsData.externalLinks.map((item, index) => (
                <a key={index}
                    href={item.source}
                    className={styles('inverted')}
                >
                    {item.title}
                </a>
            )) : []).concat(this.props.communityDetailsData ?
            this.props.communityDetailsData.legalStatementReferences.map((item, index) => (
                <Button key={index}
                    events={{ click: () => this.openTermsConditionsModal(item) }}
                    classes={styles('inverted')}
                    modifiers={['text']}
                >
                    {item.description}
                </Button>
            )) : []);

        const discoverContent = [].concat(this.props.mainTypesLoading ? [<Bar key={0} />] : [])
            .concat(this.props.mainTypesData ?
                this.props.mainTypesData.map((item, index) => (
                    <NavLink key={index}
                        to={`/items/${item.id}`}
                        className={styles('inverted')}
                    >
                        {item.name}
                    </NavLink>
                )) : []);

        const addressContent = [].concat(this.props.communityCompanyData ? [
            <Fragment key={this.props.communityCompanyData.name}>
                {this.props.communityCompanyData.name}<br />
                {this.props.communityCompanyData.address.street} {this.props.communityCompanyData.address.number}<br />
                {this.props.communityCompanyData.address.postalCode} {this.props.communityCompanyData.address.city}<br/><br/>
                {!!this.props.communityCompanyData.chamberOfCommerceNumber ? 
                    <Fragment>{`${translate('footer.chamberOfCommerce', this.props.language)}: ${this.props.communityCompanyData.chamberOfCommerceNumber}`}<br /></Fragment> : null}
                {!!this.props.communityCompanyData.vatNumber ?
                    <Fragment>{`${translate('footer.tax', this.props.language)}: ${this.props.communityCompanyData.vatNumber}`}<br /></Fragment> : null}
                {!!this.props.communityCompanyData.bankAccountNumber ? `${this.props.communityCompanyData.bankAccountNumber}` : null}
            </Fragment>
        ] : []);

        const contactContent = [].concat(this.props.communityContactData ? [
            <Fragment key={this.props.communityContactData.name}>
                {this.props.communityContactData.name}<br />
                <a href={`mailto:${this.props.communityContactData.emailAddress}`} className={styles('inverted')}>
                    {this.props.communityContactData.emailAddress}
                </a><br />
                <a href={`tel:${this.props.communityContactData.telephoneNumber}`} className={styles('inverted')}>
                    {this.props.communityContactData.telephoneNumber}
                </a>
            </Fragment>
        ] : []);

        const socialContent = [];

        const footerContent = [
            {
                title: translate('footer.columns.company', this.props.language),
                items: companyContent
            },
            {
                title: translate('footer.columns.discover', this.props.language),
                items: discoverContent
            },
            {
                title: translate('footer.columns.address', this.props.language),
                items: addressContent
            },
            {
                title: translate('footer.columns.contact', this.props.language),
                items: contactContent
            },
            {
                title: translate('footer.columns.social', this.props.language),
                items: socialContent
            }
        ];

        const termsAndConditionsModal = this.state.termsConditionsModalIsOpen && !!this.state.termsContent ? (
            <Modal
                isOpen={this.state.termsConditionsModalIsOpen}
                title={this.state.termsContent.description}
                modifiers={['large']}
                close={this.closeTermsConditionsModal}
            >
                <AsyncContent url={this.state.termsContent.source} />
            </Modal>
        ) : null;

        return (
            <footer className={styles('footer', 'container', 'b--gray-1')}   onClick={this.props.onVoid}>
                <div className={styles('content')}>
                    <div className={styles('footer__logo')}>
                        <Logo custom={!!this.props.communityDetailsData && !!this.props.communityDetailsData.applicationCustomization.footerLogoImageReference ? this.props.communityDetailsData.applicationCustomization.footerLogoImageReference.source : null} loading={this.props.communityDetailsLoading} classes={styles('footer__logo__img')} />
                    </div>
                    <ul className={styles('footer__columns', 'flex', 'flex--wrap', 'no-list-style', 'c--text-light')}>
                        {footerContent.map((footElement, index) => (
                            !footElement || !footElement.items.length ? null : (
                                <li key={index} className={styles('footer__column', 'col--50', 'col__xxs--33', 'col__xs--25', 'col__s--20')}>
                                    <h6 className={styles('footer__column__title')}>{footElement.title}</h6>
                                    <ul className={styles('no-list-style')}>
                                        {footElement.items.map((item, index) => !item ? null : (
                                            <li key={index}>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            )
                        ))}
                    </ul>
                    <div className={styles('footer__payoff', 'align--center')}>
                        <small className={styles('c--text-light')}>
                            {translate('footer.payOff', this.props.language)}
                            <Logo classes={styles('footer__payoff__img')} modifiers={['inline']} />
                        </small>
                    </div>
                </div>
                {termsAndConditionsModal}
            </footer>
        );
    }
}

Footer.propTypes = {
    // properties
    mainTypesData: PropTypes.arrayOf(PropTypes.object),
    mainTypesLoading: PropTypes.bool,

    communityDetailsData: PropTypes.object,
    communityDetailsLoading: PropTypes.bool,
    communityCompanyData: PropTypes.object,
    communityContactData: PropTypes.object,

    language: PropTypes.string.isRequired,

    onVoid: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        mainTypesData: state.list.mainTypes.data,
        mainTypesLoading: state.list.mainTypes.loading,

        communityDetailsData: state.details.community.data,
        communityDetailsLoading: state.details.community.loading,
        communityCompanyData: state.details.communityCompany.data,
        communityContactData: state.details.communityContact.data,

        language: state.global.localization.language
    };
};

export default connect(mapStateToProps, null)(Footer);



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js